import { post } from '../../../../../api/baseUrl';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../../store';

interface OptionsData {
  indicationOptions: string[];
  therapeuticAreaOptions: string[];
  therapeuticClassOptions: string[];
}

export const useGetAllCatalogMedsOptions = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );
  const [optionsData, setOptionsDataData] = useState<OptionsData>({
    indicationOptions: [],
    therapeuticAreaOptions: [],
    therapeuticClassOptions: [],
  });

  const postGetAllCatalogMedsOptions = async () => {
    if (!selectedTenancy) return;
    setIsLoading(true);
    try {
      const { data } = await post(`getAllCatalogMedsOptions`, {
        tenancyId: selectedTenancy.tenancy_id,
      });

      setOptionsDataData(data.data);
    } catch (error: any) {
      console.error('An error occurred during getAllCatalogMedsOptions', error);
      setErrorMessage(
        error?.response?.data?.message ||
          'Unknown error in getAllCatalogMedsOptions',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return {
    postGetAllCatalogMedsOptions,
    errorMessage,
    isLoading,
    optionsData,
  };
};
